import { Text } from '@vidahealth/vida-ui';

import { RadioDot, SelectableRow } from '@/modules/ui';

/** Private to CoachAvailabilityScreen — a selectable consult-time row. */
export function SlotRow({
  label,
  selected,
  onPress,
  testID,
}: {
  label: string;
  selected: boolean;
  onPress: () => void;
  testID?: string;
}) {
  return (
    <SelectableRow
      isSelected={selected}
      onPress={onPress}
      selectionRole='radio'
      accessibilityLabel={label}
      className='py-6'
      testID={testID}
    >
      <RadioDot selected={selected} />
      <Text size='md' weight='semibold' className='text-typography-900'>
        {label}
      </Text>
    </SelectableRow>
  );
}
